import type { Profession } from "@brookbush/types";

import useSWRImmutable from "swr/immutable";

const useProfessions = () => {
	const {
		data: professions,
		mutate,
		isLoading,
		...rest
	} = useSWRImmutable<Profession[]>("/professions");

	return { professions, isLoadingProfessions: isLoading, ...rest };
};

export default useProfessions;
